import React, { createContext, useContext, useEffect, useState } from 'react';
import { Router, BrowserRouter } from 'react-router-dom';
import { useLocation } from 'react-router';

import { ContextWrapper } from './wrapper.context';
import { generateUUID } from 'utils/helpers';

export const ModalContext = createContext(null);

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const businessInfoData = useContext(ContextWrapper);
  const [modals, setModals] = useState([]);
  const [modalPathname, setModalPathname] = useState(null);

  const location = useLocation();

  const closeModal = (modalId) => {
    setModals((prevModals) =>
      prevModals.filter((modal) => {
        const { modalId: id } = modal().props.children.props;
        return modalId !== id;
      })
    );
  };

  const openModal = (Component, componentProps) => {
    setModalPathname(location.pathname);

    const modalId = generateUUID();
    const ModalComponent = () =>
      componentProps?.history ? (
        <Router history={componentProps.history}>
          <Component
            {...componentProps}
            visible={true}
            centered={true}
            close={() => closeModal(modalId)}
            modalId={modalId}
          />
        </Router>
      ) : (
        <BrowserRouter>
          <Component
            {...componentProps}
            visible={true}
            centered={true}
            close={() => closeModal(modalId)}
            modalId={modalId}
          />
        </BrowserRouter>
      );
    setModals((prevModals) => [...prevModals, ModalComponent]);
  };

  useEffect(() => {
    if (modalPathname && location.pathname !== modalPathname) {
      setModals([]);
      setModalPathname(null);
    }
  }, [location.pathname, modalPathname]);

  return (
    <ModalContext.Provider
      value={{ ...businessInfoData, openModal, closeModal }}
    >
      {children}
      {modals.map((ModalComponent, index) => (
        <ModalComponent key={index} />
      ))}
    </ModalContext.Provider>
  );
};
